import { render, staticRenderFns } from "./error-code.vue?vue&type=template&id=8745f904&"
import script from "./error-code.vue?vue&type=script&lang=js&"
export * from "./error-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports